import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import * as React from "react";
import { UitkText } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkUnformattedHtml, UitkUnformattedHtmlReplaceDefaults } from "uitk-react-unformatted-html";

export const Description = ({ hotel }: { hotel: Hotel }) => {
  const { shortDescription } = hotel;

  if (!shortDescription || shortDescription.length === 0) {
    return null;
  }

  return (
    <UitkSpacing padding={{ blockstart: "two" }}>
      <UitkText overflow="truncate-3-lines" size={300}>
        <UitkUnformattedHtml
          elementsToReplace={{
            ...UitkUnformattedHtmlReplaceDefaults,
            strong: (props) => (
              <UitkText {...props} inline theme="emphasis" weight="bold">
                {props.children}
              </UitkText>
            ),
          }}
          htmlToParse={shortDescription}
        />
      </UitkText>
    </UitkSpacing>
  );
};
